// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-column[data-v-35eda188] {\n  width: 10%;\n}", ""]);
// Exports
module.exports = exports;
